export const baseUrl = `/api/${process.env.REACT_APP_API_VERSION}`;
